var _rect, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClients(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 16,
    fill: "#303030"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.1278 18.5013C32.9446 21.0435 31.0587 23.0019 29.0022 23.0019C26.9456 23.0019 25.0566 21.0441 24.8766 18.5013C24.6891 15.8565 26.5249 14.0006 29.0022 14.0006C31.4794 14.0006 33.3153 15.9046 33.1278 18.5013Z",
    stroke: "#E4FD3D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.001 27.0013C24.9278 27.0013 21.011 29.0244 20.0297 32.9644C19.8997 33.4857 20.2266 34.0013 20.7622 34.0013H37.2403C37.776 34.0013 38.101 33.4857 37.9728 32.9644C36.9916 28.9613 33.0747 27.0013 29.001 27.0013Z",
    stroke: "#E4FD3D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5029 19.6238C20.3566 21.6546 18.8323 23.254 17.1891 23.254C15.5459 23.254 14.019 21.6552 13.8752 19.6238C13.7258 17.511 15.2095 16.001 17.1891 16.001C19.1686 16.001 20.6524 17.5498 20.5029 19.6238Z",
    stroke: "#E4FD3D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8763 27.1254C19.748 26.6084 18.5053 26.4096 17.1883 26.4096C13.9378 26.4096 10.8061 28.0255 10.0216 31.1728C9.9185 31.5891 10.1798 32.0011 10.6073 32.0011H17.6258",
    stroke: "#E4FD3D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClients);
export default __webpack_public_path__ + "static/media/clients.26061abfc585b52010347c90cbe2c378.svg";
export { ForwardRef as ReactComponent };